"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import Actionable from "../Actionable/index.js";
import { classNames } from "../../utilities/props.js";
import { getLocalISODate } from "./Calendar.utils.js";
import s from "./Calendar.module.css";
const CalendarDate = (props) => {
    const { date, isoDate, startValue, endValue, disabled, focusable, onChange, range, hoveredDate, onDateHover, onDateHoverEnd, renderAriaLabel, selectedDates, } = props;
    if (!date)
        return _jsx("td", { className: s.cell, "aria-hidden": "true" });
    const isoStartValue = startValue && getLocalISODate({ date: startValue });
    const isoEndValue = endValue && getLocalISODate({ date: endValue });
    const isStartValue = !!isoDate && !!isoStartValue && isoDate === isoStartValue;
    const isEndValue = !!isoDate && !!isoEndValue && isoDate === isoEndValue;
    const isAfterStartValue = startValue && date > startValue;
    const isBeforeEndValue = endValue && date < endValue;
    const isInHoveredRange = hoveredDate && !endValue && hoveredDate > date;
    const isInSelectedDates = !!selectedDates?.find((selectedDate) => getLocalISODate({ date: selectedDate }) === isoDate);
    let selection;
    switch (true) {
        case isAfterStartValue && isInHoveredRange:
        case isAfterStartValue && isBeforeEndValue:
            selection = "range";
            break;
        case isStartValue && (!range || isEndValue):
        case isInSelectedDates:
            selection = "standalone";
            break;
        case isStartValue:
            selection = "start";
            break;
        case isEndValue:
            selection = "end";
            break;
    }
    const dateClassNames = classNames([
        s.cell,
        selection && s["--active"],
        selection && s[`--selection-${selection}`],
    ]);
    const handleClick = () => {
        if (!range) {
            onChange?.({ value: date });
            return;
        }
        const bothDatesSelected = startValue && endValue;
        const noneDatesSelected = !startValue && !endValue;
        const selectingBeforeStart = startValue && date < startValue;
        const selectingStart = bothDatesSelected || noneDatesSelected || selectingBeforeStart;
        const start = selectingStart ? date : startValue;
        const end = !selectingStart ? date : null;
        onChange?.({ value: { start, end } });
    };
    const handleMouseEnter = () => {
        onDateHover(date);
    };
    const handleMouseLeave = () => {
        onDateHoverEnd(date);
    };
    return (_jsx("td", { className: dateClassNames, role: disabled ? "presentation" : "gridcell", children: _jsx(Actionable, { fullWidth: true, insetFocus: true, className: s["cell-button"], disabled: disabled, onClick: handleClick, attributes: {
                role: "checkbox",
                tabIndex: focusable ? 0 : -1,
                "aria-hidden": disabled,
                "aria-label": renderAriaLabel
                    ? renderAriaLabel({ date })
                    : date.toLocaleDateString("en-us", { month: "long", day: "numeric", weekday: "long" }),
                "aria-checked": !!selection,
                "data-rs-date": getLocalISODate({ date }),
                onMouseEnter: handleMouseEnter,
                onMouseLeave: handleMouseLeave,
                onFocus: handleMouseEnter,
                onBlur: handleMouseLeave,
            }, children: date.getDate() }) }));
};
CalendarDate.displayName = "CalendarDate";
export default CalendarDate;
